const Addresses = () => (
  <div className="bg-white p-6 rounded-lg shadow-md">
    <h2 className="text-xl font-bold mb-4">Your Addresses</h2>
    <p>List of saved addresses will appear here.</p>
  </div>
);

export default Addresses;
